export class Utils {
    static compareArrays(a, b) {
        if (a.length !== b.length) return false;
        const uniqueValues = new Set([...a, ...b]);
        for(const v of  uniqueValues) {
            const aCount = a.filter(e => e === v).length;
            const bCount = b.filter(e => e === v).length;
            if (aCount !== bCount) return false;
        }
        return true;
    }

    static getLowerPrice(prices, product) {
        let lowerPrice = 0.0
        if (prices.length !== 0 && product) {
            product.products.forEach(e => {
                let item = prices.find(i => {
                    return i.product.id === e;
                })
                if (lowerPrice === 0 || lowerPrice > item.price_it) {
                    lowerPrice = item.price_it;
                }
            })
            return lowerPrice;
        } else return 'N/A'
    }

    static isSameCombo (a, b) {
        return parseInt(a.id) === parseInt(b.id) && parseInt(a.attribute_id) === parseInt(b.attribute_id)
    }

    static onlyLeft (left, right, compare) {
        return left.filter(lValue => {
            return !right.some(rValue => {
                return compare(lValue, rValue)
            })
        })
    }

    static isPresent(a, b) {
        const onlyInA = this.onlyLeft(a, b, this.isSameCombo)
        const onlyInB = this.onlyLeft(b, a, this.isSameCombo)
        if([...onlyInA, ...onlyInB].length === 0) return true;
        else if (onlyInA.length === 0) return true;
        else return false;
    }
}

export default new Utils()